export default __webpack_public_path__ + "static/media/Group 22.7aa876b3.png";